export default __webpack_public_path__ + "static/media/Meme.f14a49e6.jpg";